import { useMutation } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

type ReconcilePaymentPlanVariables = {
  id: string;
  amount: number;
};

export async function reconcilePaymentPlan(
  axiosInstance: Promise<AxiosInstance>,
  { id, amount }: ReconcilePaymentPlanVariables,
) {
  const instance = await axiosInstance;

  return instance.put(`payment_plans/pay_payment_steps/${id}`, { amount });
}

export function useReconcilePaymentPlan() {
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, ReconcilePaymentPlanVariables>({
    mutationFn: data => reconcilePaymentPlan(axiosInstance, data),
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    ReconcilePaymentPlanVariables,
    'reconcilePaymentPlan'
  >('reconcilePaymentPlan', mutation);
}
